export const menuList = [
  {
    label: "首页",
    value: "company-home-page",
    icon: "home",
    public: true
  },
  {
    label: "企业管理",
    value: "company-manage",
    icon: "manage",
    children: [
      {
        label: "企业信息",
        value: "company-manage-info"
      },
      {
        label: "企业操作",
        value: "company-manage-operation"
      },
      {
        label: "企业日历",
        value: "company-manage-calendar"
      }
    ]
  },
  {
    label: "组织架构",
    value: "company-structure",
    icon: "structure",
    children: [
      {
        label: "企业成员",
        value: "company-user"
      },
      {
        label: "企业角色",
        value: "company-role"
      },
      {
        label: "邀请审核",
        value: "company-review"
      }
    ]
  },
  // 2.2.6 后台管理，新增开放应用配置（API）
  // {
  //   label: "开发平台",
  //   value: "company-development-platform",
  //   icon: "data-security",
  //   children: [
  //     {
  //       label: "开放应用",
  //       value: "company-open-app"
  //     }
  //   ]
  // },
  {
    label: "数据安全",
    value: "company-data-security",
    icon: "data-security",
    children: [
      {
        label: "管理日志",
        value: "company-manage-log"
      }
    ]
  },
  {
    label: "系统对接",
    value: "company-system",
    icon: "system-joint",
    children: [
      {
        label: "系统对接",
        value: "company-system-joint"
      }
    ]
  },
  {
    label: "应用管理",
    icon: "app",
    value: "manage-app",
    children: [
      {
        label: "应用列表",
        value: "company-manage-app"
      },
      {
        label: "应用分组",
        value: "company-app-group"
      },
      {
        label: "应用模板",
        value: "company-app-template"
      }
    ]
  },
  {
    label: "项目管理",
    icon: "project",
    value: "manage-project",
    children: [
      {
        label: "项目列表",
        value: "company-manage-project"
      },
      {
        label: "项目分组",
        value: "company-project-group"
      },
      {
        label: "项目模板",
        value: "company-manage-project-template"
      },
      {
        label: "任务模板",
        value: "company-manage-task-template"
      }
    ]
  },
  {
    label: "互联管理",
    icon: "connect",
    value: "manage-connect",
    children: [
      {
        label: "互联企业",
        value: "company-manage-connect-list"
      },
      {
        label: "互联角色",
        value: "company-manage-connect-type"
      }
    ]
  }
  // {
  //   label: "其他",
  //   value: "other",
  //   icon: "el-icon-position",
  //   children: [
  //     {
  //       label: "登录日志",
  //       value: "company-manage-7"
  //     },
  //     {
  //       label: "操作日志",
  //       value: "company-manage-8"
  //     }
  //   ]
  // }
]

export const menuMap = {
  "company-invite-setting": "company-review",
  "company-joint-setting": "company-system-joint"
}
